export class UiUtils {

  private static rgbMaxValue = 255;
  /**
   * Will extract a set of integers from an RGB color string and return as an object
   * @param colorCode
   * @returns {{red: number; green: number; blue: number}}
   */
  private static extractBaseColors(colorCode): {red: number, green: number, blue: number} {
    const r: string = colorCode.slice(1, 3),
      g: string = colorCode.slice(3, 5),
      b: string = colorCode.slice(5, 7);
    const rD: number = parseInt(r, 16),
      gD: number = parseInt(g, 16),
      bD: number = parseInt(b, 16);
    return {
      red : rD,
      green: gD,
      blue: bD
    };
  }

  /**
   * Will format the given RGB integer values into a formatted RGB string as hex values
   * @param {number} red
   * @param {number} green
   * @param {number} blue
   * @returns {string}
   */
  private static formatColorString(red: number, green: number, blue: number): string {
    const leader = '0';
    const rK: string = red.toString(16);
    const gK: string = green.toString(16);
    const bK: string = blue.toString(16);
    return`#${rK.length === 1 ? leader + rK : rK} ${gK.length === 1 ? leader + gK : gK} ${bK.length === 1 ? leader + bK : bK}`
      .replace(new RegExp(' ', 'g'), '');
  }

  /**
   * Will return an RGB color code as a string that is darkened by percentage from a given input color
   * @param {string} colorCode
   * @param {number} factor
   * @returns {string}
   */
  public static darken(colorCode: string, factor: number): string {
    if (factor > 100) {
      throw new Error('Factor > 100% not valid');
    } else if (factor < 0) {
      throw new Error('Factor < 0% not valid');
    }
    const percent = factor / 100;
    const colorValues = UiUtils.extractBaseColors(colorCode);
    const rX: number = Math.floor(Math.max(0, colorValues.red - (colorValues.red * percent))),
      gX: number = Math.floor(Math.max(0, colorValues.green - (colorValues.green * percent))),
      bX: number = Math.floor(Math.max(0, colorValues.blue - (colorValues.blue * percent)));
    return UiUtils.formatColorString(rX, gX, bX);
  }

  /**
   * Will return an RGB color code as a string that is lightened by percentage from a given input color
   * @param {string} colorCode
   * @param {number} factor
   * @returns {string}
   */
  public static lighten(colorCode: string, factor: number): string {
    if (factor > 100) {
      throw new Error('Factor > 100% not valid');
    } else if (factor < 0) {
      throw new Error('Factor < 0% not valid');
    }
    const percent = factor / 100;
    const colorValues = UiUtils.extractBaseColors(colorCode);
    const rX: number = Math.floor(Math.max(0, colorValues.red + ((this.rgbMaxValue - colorValues.red) * percent))),
      gX: number = Math.floor(Math.max(0, colorValues.green + ((this.rgbMaxValue - colorValues.green) * percent))),
      bX: number = Math.floor(Math.max(0, colorValues.blue + ((this.rgbMaxValue - colorValues.blue) * percent)));
    return UiUtils.formatColorString(rX, gX, bX);
  }

}
